import styled,{keyframes} from 'styled-components';
import media from 'src/styles/Media.styled';
import { DARK_NAVY_FONT_COLOR, FONT_FAMILY_BOLD, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, SECONDARY_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX, TERTIARY_FONT_COLOR, TITLE_FONT_COLOR, WHITE_FONT_COLOR, X_SMALL_TEXT_PX, XX_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const AddCartIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: ${({ width }) => (width ? width : '14px')};
    height: ${({ height }) => (height ? height : '14px')};
    cursor: pointer;
`;

export const AddedCartButton = styled.div`
    width: ${({ width }) => (width ? width : '25px')};
    height: ${({ height }) => (height ? height : '25px')};
    display: ${({ display }) => (display ? display : 'flex')};
    position: relative;
    visibility: ${({ visibility }) => visibility};
    justify-content: center;
    align-items: center;
    border: ${({ border }) => (border ? border : '1px solid #ebebeb')};
    box-shadow: ${({ shadow }) => (shadow ? shadow : '0px 0px 2px #00000029')};
    border-radius: 6px;
    opacity: 1;
    background-color: ${({ transparentBg }) => (transparentBg ? 'transparent' : '#FFFFFF')};
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    margin-right: ${({ marginRight }) =>
        marginRight ? marginRight : '0px'}; 
    margin-top: ${({ marginTop }) =>
        marginTop ? marginTop : ''};  
`;

export const CountContainer = styled.div.attrs((props) => ({ 
    id : props.id ? props.id : 'count-badge',
}))`
    display: flex;
    justify-content: center;
    align-items: center;
    right: ${(props) => (props.right ? props.right : '-6px')};
    top: ${(props) => (props.top ? props.top : '-8px')};
    position: absolute;
    background-color: ${(props) => (props.colorNote ? '#F5F5F5' : '#12C8F7')};
    width: ${(props) =>
        props.width ? props.width : props.isMultiDigit ? '18px' : '15px'};
    min-width: ${(props) =>
        props.width ? props.width : props.isMultiDigit ? '18px' : '15px'};
    height: ${(props) =>
        props.height ? props.height : props.isMultiDigit ? '18px' : '15px'};
    min-height: ${(props) => (props.isMultiDigit ? '18px' : '15px')};
    padding: 0;
    border-radius: 50%;
    border: ${(props) =>
        props.desktopBorder ? props.desktopBorder : '1px solid #140f4b'};
    box-sizing: border-box;
    ${media.mobileDevice`
        right: ${(props) => (props.mbRight ? props.mbRight : '-6px')};
        top: ${(props) => (props.mbTop ? props.mbTop : '-8px')};
        background-color: ${(props) => props.backgroundColor};
        border : ${(props) => props.border};
    `}
`;

export const LabelCount = styled.span`
    padding-top: ${(props) => (props.isMultiDigit ? '0' : '2px')};
    display: inline-block;
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: ${(props) =>
        props.isMultiDigit ? '9px' : `${X_SMALL_TEXT_PX}`};
    text-align: center;
    letter-spacing: -0.1px;
    line-height: 1;
    font-family: ${FONT_FAMILY_DEMI};
    vertical-align: middle;
    white-space: nowrap;
    ${media.mobileDevice`
        color : ${(props) => (props.colorNote ? `${WHITE_FONT_COLOR}` : `${DARK_NAVY_FONT_COLOR}`)};
        line-height: 0;
        padding-top:1px;
    `}
`;

export const AutoCompleteTemplateHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: ${DARK_NAVY_FONT_COLOR};
    .setNumber {
        font-family: ${FONT_FAMILY_DEMI};
        margin-right: 10px;
        font-size: ${SMALL_TEXT_PX}; 
    }

    .brand {
        font-size: ${SEMANTIC_TEXT_SMALL_PX};
        font-family: ${FONT_FAMILY_REGULAR};
        &::before {
            content: '|';
            margin-left: 5px;
        }
    }
`;

export const AutoCompleteDescription = styled.div`
    font-size: ${X_SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    opacity: 0.9;
    color: ${DARK_NAVY_FONT_COLOR};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};  
    ${media.mobileDevice`
        margin: 0px 0 7px 0px;
        box-shadow:none;
    `}
`;

export const CloseDropdownText = styled.div`
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    opacity: 1;
    color: ${SECONDARY_FONT_COLOR}; 
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};  
    ${media.mobileDevice`
        margin: 0;
        box-shadow:none;
    `}
`;

export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 4px solid ${TERTIARY_FONT_COLOR};
  border-top: 4px solid ${TITLE_FONT_COLOR};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: auto;
`;

export const AutoListContainer = styled.div`
    width: ${(props) => (props.width ? props.width : '100%')};
    border-bottom: ${(props) =>
        props.bBottom ? props.bBottom : '1px solid #dee2e6'};
    padding: ${({ padding }) => (padding ? padding : '10px')};
`;

export const AutoListMainView = styled.div`
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.display ? props.display : 'flex')};
    justify-content: ${(props) =>
        props.jContent ? props.jContent : 'space-between'};
    align-items: ${(props) => (props.aContent ? props.aContent : 'center')};
`;

export const CloseDropdownLi = styled.li`
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.display ? props.display : 'flex')};
    justify-content: ${(props) =>
        props.jContent ? props.jContent : 'space-between'};
    align-items: ${(props) => (props.aContent ? props.aContent : 'center')};
`;

export const MultiDivRowView = styled.div`
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.display ? props.display : 'flex')};
`;
export const CustomText = styled.span`
    background-color: ${(props) => props.bgColor};
    font-size: ${(props) => (props.fontSize ? props.fontSize : `${XX_SMALL_TEXT_PX}`)};
    // line-height: '20px';
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : `${FONT_FAMILY_BOLD}`};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '2px')};
    color: ${(props) => props.color};
`;

export const BoxView = styled.div`
    border-radius: ${(props) => (props.bRadius ? props.bRadius : '3px')};
    margin-right: ${(props) => (props.mr ? props.mr : '2px')};
    margin-left: ${(props) => (props.ml ? props.ml : '2px')};
    margin-top: ${(props) => props.mTop};
    background-color: ${(props) => (props.bgColor ? props.bgColor : '#C2F1FD')};
    border: ${(props) =>
        props.bgBorder ? props.bgBorder : ' 1px solid #4b99ad'};
    height: ${(props) => (props.scrHeight ? props.scrHeight : ' 18px')};
    width: ${(props) => props.scrWidth ? props.scrWidth : '24px'};
    ${(props) => props.minWidth ? `min-width: ${props.minWidth};` : ''}
    padding: ${(props) => (props.boxpadding ? props.boxpadding : '0px 4px')};
    display: flex;
    justify-content: ${(props) => (props.jContent ? props.jContent : 'center')};
    align-items: ${(props) => (props.aConetnt ? props.aConetnt : 'center')};
    white-space: nowrap;
`;